import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ArmourFilterComponent } from './armour-filter/armour-filter.component';
import { BaseComponent } from '../../../common/base.component';
import { FilterTitleComponent } from '../../../common/filter-title/filter-title.component';
import { Filter, ArmourFilter } from '../../../models/filter-models';
import { FilterService } from '../../../services/filter.service';
import { ActiveSpecialRules } from '../../../services/filter-generator.service';
import { confirmRemove } from '../../../common/confirm-remove';
import { DynamicContentComponent } from '../../../common/dynamic-content/dynamic-content.component';

@Component({
  selector: 'app-my-armour-list',
  imports: [FormsModule, FilterTitleComponent, ArmourFilterComponent, DynamicContentComponent],
  templateUrl: './my-armour-list.component.html',
  styleUrl: './my-armour-list.component.scss'
})
export class MyArmourListComponent extends BaseComponent {
  @Input({ required: true }) filter!: Filter;
  @Input({ required: true }) activeSpecialRules!: ActiveSpecialRules;

  constructor(private filterService: FilterService) {
    super();
  }

  removeArmourType(index: number) {
    if (!confirmRemove('Are you sure you want to remove this Armour Type?')) return;
    this.filter.armourFilters.splice(index, 1);
    this.updateFilter();
  }

  addArmourType = () => { this.filter.armourFilters.push(new ArmourFilter()); this.updateFilter(); }

  updateFilter() {
    this.filterService.updateFilter();
  }
}
